import type { FC, ReactNode } from 'react';

import { useFeatureIsOn } from '@zen/FeatureFlag';
import type { SuggestionAttribute } from '@zen/graphql/types.generated';

import Suggestions from '../Suggestions';
import type { Suggestion } from '../types';

interface Props {
  attribute: SuggestionAttribute;
  inlineFieldNode: ReactNode;
  originalValuePresent: boolean;
  refetchQueries: string[];
  suggestions: Suggestion[];
}

export const InlineFieldWithSuggestions: FC<Props> = ({
  attribute,
  inlineFieldNode,
  originalValuePresent,
  refetchQueries,
  suggestions
}) => {
  const isSuggestionsEnabled: boolean = useFeatureIsOn('io-suggestions');

  if (!isSuggestionsEnabled || !suggestions || suggestions.length === 0) {
    return inlineFieldNode ?? '-';
  }

  const filteredSuggestions = suggestions?.filter((s) => s.targetAttribute === attribute);

  return (
    <>
      {inlineFieldNode}
      <Suggestions
        originalValuePresent={originalValuePresent ?? false}
        suggestions={filteredSuggestions}
        refetchQueries={refetchQueries}
      />
    </>
  );
};
